// extracted by mini-css-extract-plugin
var _1 = "input-error-message__nkYcZ";
export { _1 as "input-error-message" }
